<style>
@import '../blog/BlogGeneral.css';
</style>


<template>
  <div class="blog-geral" id="inicio" v-if="!this.checkIsEmpty(dicas)">
    <div class="container justify-content-center">

      <!--Link for pages navegation-->
      <section class="row p-20">
        <div class="col-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link class="text-uppercase" :to="{ name: 'home' }"
                  >Início</router-link
                >
              </li>
              <li
                class="breadcrumb-item active text-uppercase"
                aria-current="page"
              >
                Blog
              </li>
            </ol>
          </nav>
        </div>
      </section>

      <!--Title of page-->
      <section class="row">
        <div class="col-12 mb-2 text-center">
          <h1 class="h1-after-center text-uppercase font-weight-bold mb-4">
            Blog
          </h1>
        </div>
      </section>

      <!--Card of Blog -->
      <section class="container container-style">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4 mb-2 justify-content-center" v-for="(dica, index) in dicas.data"
              :key="index"
            >
              <router-link class="link" :to="{ name: 'blog-single', params: { id: dica.id } }">
                <div class="card-custom">
                  <img class="card-img-top" v-if="dica.imagem" :src="`${getImagesAddress}${dica.imagem}`"  :alt="`Imagem da dica ${dica.titulo}`">
                  <div class="card-body">
                    <h3 class="card-title">{{ dica.titulo }}</h3>
                    <!--<p class="card-text"><small class="text-muted">Data de publicação, exemplo: 20/05/20</small></p>-->
                  </div>
                </div>
              </router-link>
            </div>
          </div>
      </section>

      <!--Number of the pages-->
      <section class="row">
        <div class="col-12">
          <nav aria-label="Page navigation example">
            <ul class="pagination justify-content-center">

              <!--Left arrow-->
              <li class="page-item">
                <div
                  class="page-link c-white"
                  v-if="pagAtual > 1"
                  @click="paginar(pagAtual - 1)"
                  aria-label="Previous"
                >
                  <span aria-hidden="true">&laquo;</span>
                </div>
              </li>

              <!--Numbers of page-->
              <li
                class="page-item"
                v-for="(pagina, index) in paginas"
                :key="index"
              >
                <div class="page-link c-white" @click="paginar(pagina)">
                  {{ pagina }}
                </div>
              </li>

              <!--Right arrow-->
              <li class="page-item">
                <div
                  class="page-link c-white"
                  v-if="pagAtual < totalPaginas"
                  @click="paginar(pagAtual + 1)"
                  aria-label="Next"
                >
                  <span aria-hidden="true">&raquo;</span>
                </div>
              </li>

            </ul>
          </nav>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import makeToast from "../../mixins/makeToast";
import scrollToElement from '../../mixins/scrollToElement';

export default {
  name: "blog-geral",
  mixins: [makeToast, scrollToElement],
  data: () => ({
    pagAtual: 1,
    clickPage: document.querySelector('#page-link-active'),
    
  }),

  computed: {
    ...mapGetters('general', ['getImagesAddress']),
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      dicas: (state) => state.dicas,
      totalPaginas: (state) => state.dicas.paginacao,
      paginas: (state) => {
        const pagMax = state.dicas.paginacao;
        const paginas = [];
        let num = 0;
        while (num < pagMax) {
          num++;
          paginas.push(num);
        }
        return paginas;
      },
    }),
  },

  created() {
    this.scrollToElement();
    if (this.checkIsEmpty(this.dadosUsuario)) {
      this.$router.push({ name: 'area-restrita' });
    }
    this.$store.dispatch('startLoader');
    this.$store.dispatch('emptyDicas').then(() => {
      this.$store
        .dispatch('showDicasPag', this.pagAtual)
        .catch(() => {
          this.makeToast(
            'Oopss!',
            'Não foi possível carregar as dicas! Tente novamente em 5 minutos!',
            'danger'
          );
        })
        .finally(() => this.$store.dispatch('endLoader'));
    });
  },

  mounted(){
    this.scrollToElement();
  },

  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    paginar(pagina) {
      this.pagAtual = pagina;
      this.$store.dispatch('showDicasPag', pagina);
    },
    pageActive() {
      //this.clickPage.innerHTML += ('active');
      //this.clickPage.classList.add('active');
    },
  },
};
</script>